import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { Typography } from 'lighthouse';

import Badge from '@/widgets/Badge';

import { copyToClipboard } from '@/utilities/copyToClipboard';
import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import classes from './index.module.css';
import { BannerProps } from './models';

import { cornbar } from 'cornbar';

export const Banner = ({ bannerData, isSingle }: BannerProps) => {
    const isCopyAction = bannerData.linkTarget === 'COPY';

    const Wrapper: any = !isCopyAction ? Link : 'button';

    const handleCopyText = async () => {
        if (isCopyAction) {
            await copyToClipboard(bannerData.link);
            cornbar.show({
                title: 'عملیات موفق بود',
                description: `${bannerData.link} کپی شد!`,
                variant: 'success'
            });
        }
    };

    return (
        <Wrapper
            {...(!isCopyAction && { href: bannerData.link, prefetch: false, target: bannerData.linkTarget === 'NEW_TAB' ? '_blank' : '' })}
            onClick={handleCopyText}
            className={`block w-full ${isCopyAction ? 'all-unset cursor-pointer' : ''} ${!isSingle ? `${classes.bannerWrapper}` : ''}`}>
            <div
                className='relative flex h-[114px] flex-col items-start justify-between rounded-lg px-6 py-4 md:pr-10'
                style={{ backgroundImage: `linear-gradient(to right, ${bannerData.backgroundFrom}, ${bannerData.backgroundTo})` }}>
                <Typography
                    variant='subtitle1'
                    style={{ color: bannerData.titleColor }}
                    component='div'
                    className={`whitespace-pre-wrap text-[13px] ${classes.bannerTitle}`}>
                    {bannerData.title}
                </Typography>
                {bannerData.badge?.title && (
                    <Badge
                        color={bannerData.badge.color}
                        label={bannerData.badge.title}
                        isRounded
                        isTransParent={false}
                        className='mt-2 shrink-0 self-start'
                    />
                )}
                <Image
                    alt={bannerData.title}
                    src={getStrapiImageUrl(bannerData.image.url)}
                    width={120}
                    height={120}
                    fetchPriority={bannerData.imageLcp ? 'high' : 'auto'}
                    priority={bannerData.imageLcp}
                    loading={bannerData.imageLcp ? 'eager' : 'lazy'}
                    className='absolute -top-4 left-3.5'
                />
            </div>
        </Wrapper>
    );
};
